/**
 * InvestHub product SSO origin for KYC UI "back to InvestHub" / SSO request links.
 *
 * SSOT logic: `@investhub/kyc-dto` `resolveInvesthubSsoUrl` (M2.D).
 * Kept as a local mirror — CRA ModuleScopePlugin cannot import outside `src/`.
 *
 * Preference order:
 *   1. API publicSettings.investhub_sso_url (from INVESTHUB_SSO_URL)
 *   2. REACT_APP_INVESTHUB_SSO_URL (build-time override)
 *   3. DEV_FALLBACK_INVESTHUB_SSO_ORIGIN — lean-A only; not a prod lock-in
 */

/** @deprecated Lean-A DEV fallback — set INVESTHUB_SSO_URL / REACT_APP_INVESTHUB_SSO_URL instead. */
export const DEV_FALLBACK_INVESTHUB_SSO_ORIGIN = 'https://investhub.org'

/**
 * @param {string|{investhub_sso_url?: string}|null|undefined} publicSettingsOrUrl
 * @returns {string} origin without trailing slash
 */
export function resolveInvesthubSsoUrl(publicSettingsOrUrl) {
  const fromSettings =
    typeof publicSettingsOrUrl === 'string'
      ? publicSettingsOrUrl
      : (publicSettingsOrUrl && publicSettingsOrUrl.investhub_sso_url) || ''
  const fromEnv =
    (typeof process !== 'undefined' && process.env.REACT_APP_INVESTHUB_SSO_URL) || ''
  const raw = (fromSettings || fromEnv || DEV_FALLBACK_INVESTHUB_SSO_ORIGIN).trim()
  return raw.replace(/\/$/, '')
}
